import { db } from '@app/icare/client/db'
import { localResultQueryOptions } from '@app/icare/client/db/client/localQueryOptions'
import { jsonObjectFrom } from '@app/icare/db/query/jsonHelpers'
import type { PatientIdType } from '@app/icare/entities/patient/schema/PatientId'
import { UserSchema } from '@app/icare/entities/user/schema/User'
import { zodObjectRootKeys } from '@pkg/api/query'

export const patientCareManagerQueries = {
  forList: (patientId: PatientIdType) =>
    localResultQueryOptions({
      meta: { scope: { patientId: String(patientId), tags: ['patientCareManager'] } },
      query: db
        .selectFrom('patientCareManager')
        .selectAll()
        .where('patientId', '=', patientId)
        .where('deletedAt', 'is', null)
        .select(eb =>
          jsonObjectFrom(
            eb
              .selectFrom('user')
              .select(zodObjectRootKeys(UserSchema, 'user.'))
              .whereRef('user.id', '=', 'patientCareManager.toId'),
          ).as('to'),
        )
        .orderBy('activeFrom', 'desc'),
    }),

  forIndex: (patientId: PatientIdType) =>
    localResultQueryOptions({
      meta: { scope: { patientId: String(patientId), tags: ['patientCareManager', 'index'] } },
      query: db
        .selectFrom('patientCareManager')
        .selectAll()
        .where('patientId', '=', patientId)
        .where('deletedAt', 'is', null)
        .select(eb =>
          jsonObjectFrom(
            eb
              .selectFrom('user')
              .select(zodObjectRootKeys(UserSchema, 'user.'))
              .whereRef('user.id', '=', 'patientCareManager.toId'),
          ).as('to'),
        )
        .orderBy('activeFrom', 'desc'),
    }),
}
